module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "border1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_vm._v("INTRODUCTION: I Love Muffins and Biscuits!")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev1"
    }
  }, [_vm._v("Baking Basics")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev1"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev2"
    }
  }, [_vm._v("INGREDIENTS AND SUBSTITUTIONS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev2"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev3"
    }
  }, [_vm._v("Baking Powder and Baking Soda")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev3"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev4"
    }
  }, [_vm._v("Bananas")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev4"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev5"
    }
  }, [_vm._v("Butter")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg11lev5"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev1"
    }
  }, [_vm._v("Eggs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev1"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev2"
    }
  }, [_vm._v("Flour")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev2"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev3"
    }
  }, [_vm._v("Dairy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev3"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg15lev1"
    }
  }, [_vm._v("Nuts")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg15lev1"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg15lev2"
    }
  }, [_vm._v("Yeast")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg15lev2"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev1"
    }
  }, [_vm._v("Fruit")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev1"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev2"
    }
  }, [_vm._v("MEASURING")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev2"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev3"
    }
  }, [_vm._v("CUTTING IN")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev3"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev4"
    }
  }, [_vm._v("Rubbing")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg16lev4"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev1"
    }
  }, [_vm._v("Two Knives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev1"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev2"
    }
  }, [_vm._v("Pastry Cutter or Pastry Blender")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev2"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev3"
    }
  }, [_vm._v("Food Processor")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev3"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev4"
    }
  }, [_vm._v("Muffin Basics")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev4"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev5"
    }
  }, [_vm._v("MIXING THE BATTER")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg17lev5"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg19lev1"
    }
  }, [_vm._v("TO LINE OR NOT TO LINE?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg19lev1"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg19lev2"
    }
  }, [_vm._v("MUFFIN SIZES AND BAKING")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg19lev2"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev1"
    }
  }, [_vm._v("STORING MUFFINS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev1"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev2"
    }
  }, [_vm._v("Muffins")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev2"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev3"
    }
  }, [_vm._v("Muffin Batter")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg20lev3"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev1"
    }
  }, [_vm._v("Biscuit Basics")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev1"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev2"
    }
  }, [_vm._v("HANDLING BISCUIT DOUGH")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev2"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev3"
    }
  }, [_vm._v("Keep It Cold")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev3"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev4"
    }
  }, [_vm._v("Use a Light Hand")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev4"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev5"
    }
  }, [_vm._v("Give Your Biscuits a Rest")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev5"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev6"
    }
  }, [_vm._v("CUTTING BISCUITS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev6"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev7"
    }
  }, [_vm._v("Biscuit Cutter")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg21lev7"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev1"
    }
  }, [_vm._v("Sharp Knife")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev1"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev2"
    }
  }, [_vm._v("BAKING BISCUITS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev2"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev3"
    }
  }, [_vm._v("STORING BISCUITS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg22lev3"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg23lev1"
    }
  }, [_vm._v("Streusel Basics")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg23lev1"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg23lev2"
    }
  }, [_vm._v("Basic Streusel")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg23lev2"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MUFFINS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01chapter01#part1ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bake-Sale Berry Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08part01chapter01#part1ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09part01chapter02#part1ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balsamic Strawberry Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09part01chapter02#part1ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10part01chapter03#part1ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger-Peach Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10part01chapter03#part1ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11part01chapter04#part1ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry-Orange Muffins with Orange Glaze")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11part01chapter04#part1ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12part01chapter05#part1ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot-Almond Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12part01chapter05#part1ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13part01chapter06#part1ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piña Colada Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13part01chapter06#part1ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14part01chapter07#part1ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sour Cream–Coffee Cake Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14part01chapter07#part1ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15part01chapter08#part1ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Glory Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15part01chapter08#part1ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16part01chapter09#part1ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana, Walnut, and Chocolate Chip Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16part01chapter09#part1ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17part01chapter10#part1ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Chocolate–Zucchini Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17part01chapter10#part1ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18part01chapter11#part1ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon-Apple Oatmeal Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18part01chapter11#part1ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19part01chapter12#part1ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin-Spice Muffins with Pumpkin Seed Topping")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19part01chapter12#part1ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20part01chapter13#part1ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20part01chapter13#part1ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21part01chapter14#part1ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Lemon–Poppy Seed Muffins with Lemon Glaze")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21part01chapter14#part1ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22part01chapter15#part1ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter and Jelly Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22part01chapter15#part1ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23part01chapter16#part1ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole-Wheat Banana Millet Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23part01chapter16#part1ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24part01chapter17#part1ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarte Tatin Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24part01chapter17#part1ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25part01chapter18#part1ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spelt and Pearl Barley Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25part01chapter18#part1ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26part01chapter19#part1ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Rice and Shiitake Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26part01chapter19#part1ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27part01chapter20#part1ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa Muffins with Cheddar, Apples, and Rosemary")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27part01chapter20#part1ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28part01chapter21#part1ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Olive Oil, Chèvre, and Pine Nut Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28part01chapter21#part1ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29part01chapter22#part1ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Corn and Masa Muffins with Bacon and Jalapeños")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29part01chapter22#part1ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30part01chapter23#part1ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cider–Corn Bread Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/30part01chapter23#part1ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31part01chapter24#part1ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpernickel Muffins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31part01chapter24#part1ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32part01chapter25#part1ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham and Fontina Breakfast Hand Pies")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/32part01chapter25#part1ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33part01chapter26#part1ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pancakes and Waffles")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/33part01chapter26#part1ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34part01chapter27#part1ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muffin Bread Pudding")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/34part01chapter27#part1ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/35part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/35part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36part02chapter01#part2ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfectly Easy Cream Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/36part02chapter01#part2ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37part02chapter02#part2ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cathead Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/37part02chapter02#part2ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38part02chapter03#part2ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angel Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/38part02chapter03#part2ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39part02chapter04#part2ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultra-Flaky Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/39part02chapter04#part2ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40part02chapter05#part2ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Oil–Sweet Potato Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/40part02chapter05#part2ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41part02chapter06#part2ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey-Lavender Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41part02chapter06#part2ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42part02chapter07#part2ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham, Thyme, and Orange Zest Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/42part02chapter07#part2ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43part02chapter08#part2ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dill and Onion Whole-Wheat Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/43part02chapter08#part2ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44part02chapter09#part2ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buckwheat Gruyère Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/44part02chapter09#part2ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45part02chapter10#part2ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosemary-Parmesan Pinwheel Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/45part02chapter10#part2ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46part02chapter11#part2ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar-Bacon Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/46part02chapter11#part2ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47part02chapter12#part2ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Chile–Cornmeal Biscuits")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/47part02chapter12#part2ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48part02chapter13#part2ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuit ’n’ Eggs")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/48part02chapter13#part2ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49part02chapter14#part2ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuit Breakfast Sandwich")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/49part02chapter14#part2ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50part02chapter15#part2ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baklava Cinnamon Rolls")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/50part02chapter15#part2ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51part02chapter16#part2ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig-Chutney Breakfast Rolls")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/51part02chapter16#part2ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52part02chapter17#part2ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Monkey Bread with Pecans and Bourbon Sauce")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/52part02chapter17#part2ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53part02chapter18#part2ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pistachio-Strawberry Shortcakes with White Chocolate Cream")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/53part02chapter18#part2ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54part02chapter19#part2ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuit Strata")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/54part02chapter19#part2ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("butters "), _c('span', {
    staticClass: "font4"
  }, [_vm._v("w")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_vm._v("spreads")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/55part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56part03chapter01#part3ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Butter")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/56part03chapter01#part3ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57part03chapter02#part3ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Butter")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/57part03chapter02#part3ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58part03chapter03#part3ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Herb Butter")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/58part03chapter03#part3ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59part03chapter04#part3ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Lemon Curd")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/59part03chapter04#part3ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60part03chapter05#part3ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig and Orange Chutney")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/60part03chapter05#part3ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61part03chapter06#part3ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brown Sugar–Bourbon Sauce")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/61part03chapter06#part3ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62part03chapter07#part3ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tangerine–Vanilla Bean Marmalade")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/62part03chapter07#part3ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part03chapter08#part3ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Strawberry Preserves")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/63part03chapter08#part3ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/64index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/64index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/65acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/65acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/66author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/66author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29094afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05contents.vue
// module id = 69
// module chunks = 0